<template>
  <div style="background-color: lightcyan; overflow-x: visible;">

    <span>Plate: {{plate.name}}</span>
    <v-btn ref="btnSelect" @click="btnSelect_click($event)">Select</v-btn>
    <v-btn ref="btnSelect2" @click="btnSelect2_click($event)">A5</v-btn>
    <v-btn ref="btnSelect3" @click="btnSelect3_click($event)">A5-A12</v-btn>
    <hot-table
      ref="hot"
      :root="root"
      license-key="non-commercial-and-evaluation"
    >
      <!--          :settings="hotSettings"-->

      <plate-96-cell-renderer ref="renderer" hot-renderer></plate-96-cell-renderer>
    </hot-table>

    <div style="background-color: #EEEEFF; text-align: center;">
      bottom border of Plate
    </div>

  </div>
</template>

<script>

	import {HotWell} from '../../models'
	import {Plate} from '../../models/Plate'

	import Vue from 'vue'
	import format from 'string-format'


	import {
		VContainer, VLayout, VRow, VCol
	} from 'vuetify'

	import {HotTable, HotColumn} from '@handsontable/vue'
	import Handsontable from 'handsontable'

	import WellOfPlateComponent from './WellOfPlateComponent'
	import Plate96CellRenderer from "./Plate96CellRenderer"


	export default {
		name: "plate-96",
		components: {
			VContainer, VLayout, VRow, VCol,
			HotTable, HotColumn,
			// WellOfPlateComponent,
			'plate-96-cell-renderer': Plate96CellRenderer,
		},
		data: function () {
			return {
				wells: [],
				root: 'root-hot',

				// без привязки к свойству settings тэга hot-table
				// чтобы уменьшить количество перерисовок при изменении настроек
				hotSettings: {
					width: 42 * 12 + 25 + 0,
					height: 42 * 8 + 25 + 2,
					//autoColumnSize: {syncLimit: 12},
					colWidths: "42px",
					rowHeights: "42px",
					rowHeaderWidth: 25,
					columnHeaderHeight: 25,
					data: Handsontable.helper.createSpreadsheetData(0, 0),
					colHeaders: [],
					rowHeaders: [],
					// cells: this.cells,
					//renderCell: this.renderCell,

					contextMenu: {
						items: {
							'row_above': {},
							'a-965': {
								name: "Text Hallo",
								callback: function () {
									alert('hallo')
								}
							}
						}
					},
					afterSelectionEnd: this.hot_afterSelectionEnd,
					afterOnCellMouseOver: this.hot_afterOnCellMouseOver,
					beforeOnCellMouseOut: this.hot_beforeOnCellMouseOut,
					outsideClickDeselects: false,
					// preventOverflow: 'horizontal',
					// stretchH: true,
					// renderer: this.renderCell,
					licenseKey: 'non-commercial-and-evaluation',
				}
			}
		},

		props: {
			plate: {type: Object, default: () => null},
			selected_wells: {type: Array, default: () => []}
		},

		watch: {
			plate: function (new_value, old_value) {
				console.debug("Plate96Component.watch.plate()")
				this.update_plate()
			},

			selected_wells: function (new_value, old_value) {
				console.debug(format(
					"Plate96Component.watch.selected_wells( {0} )",
					this.selected_wells))
				let k = 15

				const changed = !(
					new_value.every((wn) => old_value.indexOf(wn) != -1) &&
					old_value.every((wn) => new_value.indexOf(wn) != -1))

				if (changed) {
					let coords = []
					for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
						const well_num = this.selected_wells[sw_i]
						const c = this.plate.get_coords(well_num)
						coords.push([c.row, c.col, c.row, c.col])
					}
					this.hot.selectCells(
						coords,
						true, false)
				}
			},
		},

		computed: {
			hot: function () {
				return this.$refs.hot.hotInstance
			},
		},

		mounted: function () {
			console.debug("Plate96Component.mounted()")

			this.update_plate()
		},

		// created: function () {
		// 	console.debug("Plate96Component.created() ")
		// },
		//
		// beforeMount: function () {
		// 	console.debug("Plate96Component.beforeMount()")
		// },
		//
		// mounted: function () {
		// 	this.update_plate()
		// },

		methods: {

			update_plate: function () {
				console.debug(format(
					"Plate96Component.update_plate('{0}') start ...",
					this.plate.name))

				// такой подвыверт не помогает, похоже рендерер позже создается
				// this.$refs.renderer.setPlate(this.plate)

				// let a = new Array(this.plate_frame.rows.length * this.plate_frame.cols.length)
				// for (let i = 0; i < a.length; i++) {
				// 	a[i] = new HotWell()
				// }
				if (this.plate) {
					// this.hot.clear()
					console.debug("Plate96Component.update_plate() data building...")

					const data = Handsontable.helper.createSpreadsheetData(
						this.plate.plate_frame.rows.length,
						this.plate.plate_frame.cols.length)
					console.debug("Plate96Component.update_plate() data builded")

					for (let row_i = 0; row_i < this.plate.plate_frame.rows.length; row_i++)
						for (let col_i = 0; col_i < this.plate.plate_frame.cols.length; col_i++) {

							// TODO: класс планшеты должен считать номер лунки
							//       или возвращать объект лунки по координатам в планшете
							const well_num = this.plate.plate_frame.cols.length * row_i + col_i
							const well = this.plate.wells[well_num]

							data[row_i][col_i] = well
						}

					this.hotSettings.data = data
					console.debug("Plate96Component.update_plate() build rows & cols headers")
					// this.hotSettings.plate = this.plate
					this.hotSettings.rowHeaders = this.buildRowHeaders()
					this.hotSettings.colHeaders = this.buildColHeaders()
					this.hot.updateSettings(this.hotSettings)

				} else {
					let k = 5
				}

				console.debug("Plate96Component.update_plate() end")
			},

			// update: function () {
			// 	this.update_plate()
			// },

			buildColHeaders: function () {
				const colHeaders = this.plate.plate_frame.cols.map(({index, title}) => title)
				// console.debug(format("Plate96Component.buildColHeaders() {0}", colHeaders))
				return colHeaders
			},

			buildRowHeaders: function () {
				const rowHeaders = this.plate.plate_frame.rows.map(({index, title}) => title)
				// console.debug(format("Plate96Component.buildRowHeaders() {0}", rowHeaders))
				return rowHeaders
			},

			// cells: function (row_i, col_i, prop) {
			// 	// console.debug("Plate96Component.hotSettings.cells()")
			//
			// 	let cellProperties = {}
			// 	if (this.plate != Plate.empty_plate) {
			// 		// console.debug("Plate96Component.hotSettings.cells() this.plate")
			// 		const well_num = this.plate.plate_frame.cols * row_i + col_i
			// 		const well = this.plate.wells[well_num]
			// 		cellProperties.well = well
			// 	}
			// 	return cellProperties
			// },

			// renderCell: function (hotInstance, td, row, column, prop, value, cellProperties) {
			// 	console.debug('Plate96Component.renderCell() ')
			//
			// },

			// -- handle controls' events --

			btnSelect_click: function (event) {
				this.hot.selectCell(1, 4)
			},

			btnSelect2_click: function (event) {
				this.hot.selectCell(0, 4)
			},

			btnSelect3_click: function (event) {
				this.hot.selectCells([[0, 4, 0, 11],])
			},

			/**
			 *
			 */
			hot_afterSelectionEnd: function (row, col, row2, col2, level) {

				let selected = Array()
				// преобразуем список выделенных областей в список
				// номеров выделенных ячеек в порядке well_num
				const range_list = this.hot.getSelectedRange()
				for (let range_i = 0; range_i < range_list.length; range_i++) {
					const range = range_list[range_i]
					const from_row = Math.max(0, Math.min(range.from.row, range.to.row))
					const to_row = Math.max(range.from.row, range.to.row)
					const from_col = Math.max(0, Math.min(range.from.col, range.to.col))
					const to_col = Math.max(range.from.col, range.to.col)

					for (let row_i = from_row; row_i <= to_row; row_i++)
						for (let col_i = from_col; col_i <= to_col; col_i++) {
							const well_num = row_i * this.plate.plate_frame.cols.length + col_i
							selected.push(well_num)
						}
				}

				this.$emit('selected', selected)
			},

			hot_afterOnCellMouseOver: function (e, coords, TD) {
				// console.log(format("Plate96Component.hot_afterOnCellMoseOver( {0} )", coords))

				let hovered = -1
				if (coords.row >= 0 && coords.col >= 0) {
					hovered = this.plate.plate_frame
						.coords_to_well_num(coords.row, coords.col)
					this.$emit('hovered', hovered)
				}
			},

			hot_beforeOnCellMouseOut: function (e, coords, TD) {
				// console.log(format("Plate96Component.hot_beforeOnCellMoseOut( {0})", coords))

				let hovered = -1
				this.$emit('hovered', hovered)
			},
		}
	}
</script>

<style>
  @import '../../../node_modules/handsontable/dist/handsontable.full.css';

  .down {
    /*z-index: 1 !important;*/
    width: inherit;
  }

  .found {
    /*z-index: 1 !important;*/
    background-color: #fcedd9 !important;
    color: #583707;
  }

  .dot {
    /*z-index: 1 !important;*/
    /*height: 16px;*/
    /*width: 16px;*/
    border-radius: 50%;
    /*display: inline-block;*/
  }

  .ht_clone_left th {
    /*z-index: 1 !important;*/
    vertical-align: middle;
  }

  .handsontable td {
    padding: 0px;
  }

  .ht_clone_left {
    z-index: 2;
  }

  .ht_clone_top {
    z-index: 2;
  }

  .ht_clone_top_left_corner {
    z-index: 2;
  }

  .handsontable .wtBorder .area {
    z-index: 2;
  }

  .handsontable .wtBorder .current {
    z-index: 2;
  }


  /*.ht_clone_top {*/
  /*  !* чтобы заголовки колонок не накрывали выпадающие меню *!*/
  /*  z-index: 8 !important;*/
  /*}*/

</style>